"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineQrcodeRedirectModule = void 0;
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var backend_services_1 = require("@src/services/backend-services");
var ci_component_injector_service_1 = require("@src/services/ci-component-injector.service");
var object_service_1 = require("@src/services/object-service");
var offline_fms_service_1 = require("@src/services/offline-fms.service");
var settings_service_1 = require("@src/services/settings.service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var OfflineQrcodeRedirectModule = /** @class */ (function () {
    function OfflineQrcodeRedirectModule() {
        this.settingService = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.qrCode = (0, cash_dom_1.default)('<ci-qrcode>');
        this.link = (0, cash_dom_1.default)('<a target="_blank">');
    }
    OfflineQrcodeRedirectModule.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (0, ci_component_injector_service_1._InjectStencilWebComponents)();
                        this.qrCode.attr('icon', 'https://cdn.prod.website-files.com/64a818dbf81993ff7b545329/66fd4c15f80951fc3ecf9005_TopFit_Logo_hoch_black.png');
                        this.qrCode.attr('module-color', 'black');
                        this.qrCode.attr('position-center-color', 'black');
                        this.qrCode.attr('position-ring-color', 'black');
                        this.qrCode.attr('icon-size', '130px');
                        this.qrCode.attr('squares', 'false');
                        if (!!this.dailyNonce) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.fetchNonce()];
                    case 1:
                        _a.dailyNonce = _b.sent();
                        _b.label = 2;
                    case 2: return [4 /*yield*/, this.updateQRCodeLink()];
                    case 3:
                        _b.sent();
                        // Use 15 minutes (900000ms) interval
                        setInterval(this.updateQRCodeLink.bind(this), 60000);
                        this.link.append(this.qrCode);
                        this.$container.append(this.link);
                        return [2 /*return*/];
                }
            });
        });
    };
    OfflineQrcodeRedirectModule.prototype.updateQRCodeLink = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, url;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                try {
                    token = offline_fms_service_1.OTPFunnelService.generateToken(this.dailyNonce);
                    url = ((_c = (_b = (_a = this.settingService) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.otpFMS) === null || _c === void 0 ? void 0 : _c.redirectOnScan) + "?otptoken=".concat(token.otp, "&ts=").concat(token.generatedAt) ||
                        "http://localhost:8080/topfit/membership/standort.html?otptoken=".concat(token.otp, "&ts=").concat(token.generatedAt);
                    if ((_g = (_f = (_e = (_d = this.settingService) === null || _d === void 0 ? void 0 : _d.get) === null || _e === void 0 ? void 0 : _e.otpFMS) === null || _f === void 0 ? void 0 : _f.setStudioId) === null || _g === void 0 ? void 0 : _g.length) {
                        url += '&studioId=' + this.settingService.get.otpFMS.setStudioId;
                    }
                    if ((_l = (_k = (_j = (_h = this.settingService) === null || _h === void 0 ? void 0 : _h.get) === null || _j === void 0 ? void 0 : _j.otpFMS) === null || _k === void 0 ? void 0 : _k.setStudioName) === null || _l === void 0 ? void 0 : _l.length) {
                        url += '&studioName=' + this.settingService.get.otpFMS.setStudioName;
                    }
                    this.link.attr('href', url);
                    this.qrCode.attr('contents', url);
                    console.log('QR code updated:', url);
                }
                catch (error) {
                    console.error('Error updating QR code link:', error);
                }
                return [2 /*return*/];
            });
        });
    };
    OfflineQrcodeRedirectModule.prototype.fetchNonce = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, backend_services_1.betterFetch)((0, infrastructure_const_1._GetCloudFunctionUrl)('fms') + '/nonce')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, data.nonce];
                }
            });
        });
    };
    return OfflineQrcodeRedirectModule;
}());
exports.OfflineQrcodeRedirectModule = OfflineQrcodeRedirectModule;
